export default "__VITE_ASSET__DcEQK0ov__"